import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationAR from './locales/ar/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEN },
      ar: { translation: translationAR }
    },
    fallbackLng: 'en',
    interpolation: { escapeValue: false }
  });

export default i18n;


    // import { useTranslation } from 'react-i18next';
    //   const { t } = useTranslation();
    //     t('welcomeMessage')